import { Store } from '@reduxjs/toolkit';
import { WeblabId, WeblabTreatment } from 'src/constants/weblab';
import { getAllMetaTagData } from '../utils/metaTags';
import { weblabsActions } from './slices/weblabs';
import type { AppState } from './store';

/**
 * Initializes the Redux store with data from meta tags.
 * This function should be called before the application renders
 * to ensure the store has the correct initial state.
 *
 * Currently handles:
 * - Weblab treatments from meta tags
 *
 * @param store - The Redux store instance to initialize
 */
export const initializeStore = (store: Store<AppState>) => {
  const metaTagData = getAllMetaTagData();
  const weblabTreatments = { ...metaTagData.weblabTreatments };

  // Standalone dev (bb server with local mocks) has no MONS to inject weblab treatments,
  // so force the credentials pilot into T1 to exercise the gated credential surfaces locally.
  // Matches the SERVER_MODE gate used to enable the mock service worker.
  if (process.env.NODE_ENV === 'development' && SERVER_MODE === 'standalone') {
    weblabTreatments[WeblabId.CredentialsPilotLaunch] = WeblabTreatment.T1;
  }

  store.dispatch(weblabsActions.setWeblabs(weblabTreatments));
};
